import * as fromUsers from '../reducers/users';

export const getIsFetching = (state) => fromUsers.getIsFetching(state.users);
export const getErrorMessage = (state) =>
    fromUsers.getErrorMessage(state.users);
export const getSuccessMessage = (state) =>
    fromUsers.getSuccessMessage(state.users);
